import React from 'react';
import { CloseButton, Col, Form, } from 'react-bootstrap';

const OrderPayFields = ({ index, item, paymentOptions, payError, handlePaymentModeChange, handlePaymentChange, removePayment }) => {
  return (
    <>
      <Col md={6}>
        <Form.Group controlId={`paymentMode${index}`}>
          <Form.Label>Payment Mode</Form.Label>
          <Form.Select defaultValue={item.paymentModeValue} onChange={handlePaymentModeChange}>
            {paymentOptions.map((option, i) => (
              <option key={i} value={i}>
                {option}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group controlId={`paymentAmount${index}`}>
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="text"
            value={item.paymentValue}
            onChange={handlePaymentChange}
            isInvalid={!!payError}
          />
          {payError && <Form.Control.Feedback type="invalid">Amount is required</Form.Control.Feedback>}
        </Form.Group>
      </Col>
      {index > 0 && (
        <CloseButton onClick={() => removePayment(item.id)} variant="danger" />
      )}
    </>
  );
};

export default OrderPayFields;